// Vibrant Yellow Tech design
const VibrantYellowDesign = {
  id: 'vibrant-yellow',
  name: 'Vibrant Yellow',
  category: 'tech',
  description: 'Bright yellow primary with contrasting dark tech accents',
  colors: {
    primary: "#FFC107",    // Vibrant Yellow (Amber)
    secondary: "#343a40",  // Dark Charcoal
    tertiary: "#6c757d",   // Medium Grey
    quaternary: "#adb5bd", // Light Grey
    accent1: "#FFC107",    // Vibrant Yellow
    accent2: "#343a40",    // Dark Charcoal
    accent3: "#007bff",    // Standard Blue (optional accent)
    accent4: "#6c757d",    // Medium Grey
    // Add other accents if needed
    text: "#212529",       // Near Black Text
    textSecondary: "#6c757d", // Medium Grey Secondary Text
    background: "#ffffff", // White background
    sidebarBackground: "#f8f9fa", // Very Light Grey sidebar
    border: "#ced4da",     // Light Grey border
  },
};

export default VibrantYellowDesign; 